

















































import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'
import { AnnouncementDto } from '@/models/dtos/announcementDto'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AnnouncementService as _announcementService } from '@/services/announcement.service'
import { UserService as _userService } from '@/services/user.service'
import { UserMixin } from '@/mixins/userMixin'
import { UserDto } from '@/models/dtos/userDto'
import { mixins } from 'vue-class-component'
import { PaginationDto } from '@/models/dtos/paginationDto'

@Component
export default class Announcement extends mixins(UserMixin) {
  // Data
  private loading: boolean = false
  private announcement: PagedResponseDto<AnnouncementDto> | null = null
  private users: UserDto[] | null = null
  private pagination: PaginationDto = { pageNumber: 1, pageSize: 15 }

  // Getters
  private get isLoaded() {
    return this.loading || (this.announcement && this.users)
  }

  // Methods
  private async getAnnouncements() {
    this.announcement = await _announcementService.getAll(this.pagination.pageNumber, this.pagination.pageSize)
  }

  // Lifecycle
  async created() {
    this.users = await _userService.getUsers()
    await this.getAnnouncements()
  }
}
